import { useState } from "react";
import { Smile } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const SETS = [
  ["Beliebt", "😂 ❤️ 😍 🥰 😘 😊 🥹 😭 🔥 ✨ 💖 💕 👏 🙌 🎉 👍 💯 😎 🤩 😅 🙈 🤗 💪 🥳"],
  ["Smileys", "😀 😃 😄 😁 😆 🤣 🙂 😉 😇 😋 😜 🤪 😝 🤭 🤫 🤔 😐 🙄 😏 😬 😌 😴 🥺 😢 😤 😡 🤯 😱 😳 🤤 🥴 😵 🤠 🤓 😈"],
  ["Herzen", "❤️ 🩷 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝 💟 😻 💋 🌹 💐"],
  ["Gesten", "👍 👎 👌 ✌️ 🤞 🫶 🤟 🤘 🤙 👋 👏 🙌 👐 🤲 🙏 💪 🫡 🤝 ☝️ 👆 👇 👉 👈 ✋"],
  ["Spaß", "🎉 🎊 🎁 🎈 🎂 🍰 🥂 🍾 🎬 🎥 📸 🎤 🎧 🎮 🏆 🥇 ⭐ 🌟 ⚡ 🌈 ☀️ 🌸 🦄 🐶 🐱 🍕 🍔 🍦 ☕ ✈️"],
].map(([name, list]) => [name, list.split(" ")]);

export function EmojiButton({ inputRef, value, onChange, testId, className = "w-10 h-10" }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const insert = (e) => {
    const el = inputRef?.current;
    const start = el?.selectionStart ?? value.length, end = el?.selectionEnd ?? value.length;
    onChange(value.slice(0, start) + e + value.slice(end));
    requestAnimationFrame(() => { if (!el) return; el.focus(); el.setSelectionRange(start + e.length, start + e.length); });
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} title="Emoji einfügen" aria-label="Emoji einfügen"
          className={`${className} shrink-0 rounded-full flex items-center justify-center text-rose-500 hover:bg-rose-50 transition-colors ${open ? "bg-rose-50" : ""}`}><Smile className="w-5 h-5" /></button>
      </PopoverTrigger>
      <PopoverContent align="end" collisionPadding={8} className="w-[20rem] max-w-[calc(100vw-16px)] p-2 rounded-2xl border-pink-100" data-testid={`${testId}-panel`} onOpenAutoFocus={(e) => e.preventDefault()} onCloseAutoFocus={(e) => e.preventDefault()} onFocusOutside={(e) => e.preventDefault()}>
        <div className="flex gap-1 overflow-x-auto no-scrollbar pb-1.5 border-b border-pink-50">
          {SETS.map(([n], i) => (
            <button key={n} type="button" onClick={() => setTab(i)} data-testid={`${testId}-tab-${i}`}
              className={`shrink-0 px-2 h-7 rounded-full text-xs font-bold transition-colors ${tab === i ? "pink-gradient text-white" : "text-slate-500 hover:bg-rose-50"}`}>{n}</button>
          ))}
        </div>
        <div className="grid grid-cols-8 gap-0.5 pt-1.5 max-h-48 overflow-y-auto">
          {SETS[tab][1].map((e, i) => (
            <button key={`${e}${i}`} type="button" onClick={() => insert(e)} data-testid={`${testId}-emoji-${i}`}
              className="h-9 rounded-lg text-xl hover:bg-rose-50 active:scale-90 transition-transform">{e}</button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
